module.exports = __webpack_public_path__ + "7c3bd71b226f9ea37052210af6b6bb62.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/sx.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/sx.svg
// module chunks = 0